/**
 * Debug Token - Função para testar se o token está sendo enviado corretamente
 */

import { API_URL } from '../config/api';

export const debugToken = async () => {
  console.log('🔍 Iniciando debug do token...');
  
  // 1. Verificar se existe token no localStorage
  const authToken = localStorage.getItem('auth_token');
  const token = localStorage.getItem('token');
  
  console.log('📦 Tokens no localStorage:');
  console.log('   auth_token:', authToken ? authToken.substring(0, 50) + '...' : 'null');
  console.log('   token:', token ? token.substring(0, 50) + '...' : 'null');
  
  const finalToken = authToken || token;
  
  if (!finalToken) {
    console.log('❌ Nenhum token encontrado no localStorage');
    return { success: false, message: 'Nenhum token encontrado' };
  }
  
  // 2. Testar envio do token para o backend
  try {
    console.log('🌐 Testando envio do token para o backend...');
    
    const response = await fetch(`${API_URL}/api/debug/token`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${finalToken}`,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await response.json();
    
    console.log('📡 Resposta do backend:', data);
    
    if (data.success) {
      console.log('✅ Token válido!');
      console.log('   Usuário:', data.decoded.name);
      console.log('   Email:', data.decoded.email);
      return { success: true, data };
    } else {
      console.log('❌ Token inválido:', data.message);
      return { success: false, data };
    }
    
  } catch (error) {
    console.error('❌ Erro ao testar token:', error);
    return { success: false, error: error.message };
  }
};

// Função para ser chamada no console do navegador
window.debugToken = debugToken;
